import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { Observable } from "rxjs";

/**
 * Custom TranslateLoader that adds cache busting query parameter to translation file URLs
 */
export class CachedTranslateHttpLoader implements TranslateLoader {
    constructor(
        private http: HttpClient,
        private prefix: string = '/assets/i18n/',
        private suffix: string = '.json',
        private cacheKey?: string
    ) {}

    /**
     * Gets the translations from the server with cache busting query parameter
     */
    public getTranslation(lang: string): Observable<Object> {
        const url = this.buildUrl(lang);
        return this.http.get(url);
    }

    /**
     * Builds the URL with cache busting query parameter
     */
    private buildUrl(lang: string): string {
        const baseUrl = `${this.prefix}${lang}${this.suffix}`;

        if (this.cacheKey) {
            return `${baseUrl}?v=${this.cacheKey}`;
        }

        return baseUrl;
    }
}
